export default __webpack_public_path__ + "static/media/Guénola_Nonet_AHV_In_Moms_We_Trust.cb016da7.jpg";